
import { useSensors, useSensor, PointerSensor, TouchSensor, KeyboardSensor } from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

export const useTaskSensors = () => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5, // Desktop precision
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 150, // Prevent accidental drags on mobile
        tolerance: 8, // More forgiving for finger precision
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
  
  return sensors;
};
